import { render, staticRenderFns } from "./appeal-cycle.vue?vue&type=template&id=2d8c54a3"
import script from "./appeal-cycle.vue?vue&type=script&lang=js"
export * from "./appeal-cycle.vue?vue&type=script&lang=js"
import style0 from "./appeal-cycle.vue?vue&type=style&index=0&id=2d8c54a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports